<template>
  <div class="carousel_wrap" id="screen0">
    <el-carousel  :autoplay="true" :interval="4000" hover-stop  class="hidden-xs-only lb" @change="resetAnimation"  height="calc(100vh - 80px)"> 
      <el-carousel-item class="lbItem"  v-for="(item, index) in imgList" :key="index"  >
      <a :href="item.explains" target="_blank" >
      <!-- <a href="/nscZl" target="_blank"> -->

     
          <img :src="item.photo" alt="" class="img_item1"  />
       
        <!-- <div :class="index ==0?'tips_font slide-content':'tips_font tips_font slide-content'">
          <h1 style="width: 100vw;text-align: center; "  :class="['animated-title', {'animate': currentIndex === index && item.remarks=='下落'}]" >
            <img src="../../assets/8.4/banner1FontNew.png" style="width: 60vw !important;display: block; margin: 0 auto;" />
          </h1>         
        </div> -->

         </a>  
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.photo"  alt="" class="img_item" />
        <div class="tips_font">
          <!-- <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1> -->
        </div>
      </el-carousel-item>
    </el-carousel>
    
    <div class="nextModules bounce-element" @click="goNext" > 
      <!-- <i class="el-icon-bottom"></i> -->
      
      <i class="el-icon-bottom"  style="font-size: 1.5rem;"></i>
    </div>

  </div>
</template>

<script>
  import API from '@/api/index'

export default {
  data() {
    return {
      currentIndex: 0,
      imgList: [
        // {
        //   src: require('@/assets/img2/gs2.png'),
        //   line1: '产业大脑',
        //   line2: '赋能产业高质量发展',
        // }
      ],
    }
  },
 
   mounted() {
    this.getRotationFn()    // 获取轮播图
  
},
  methods: {
    goFn1(){
      debugger
      alert(1111)
    },
    goNext(){
      this.$nextTick(() => {
        // document.documentElement.scrollTop = 600
        window.scrollTo({
          top: window.innerHeight,
          behavior: 'smooth'
        });
      });
     
    },
    resetAnimation(index) {
      this.currentIndex = index
    },
    // 获取党建一级页面左侧轮播图
    async getRotationFn() {
      try {
        let paramsObj={
        type:0
      }
        const res = await API.getRotation(paramsObj)
         this.imgList=res.data.resultData
         
        } catch (error) {
        }
      },
    }
}
</script>

<style lang="scss" scoped>

  /*指示器*/
  .lb .el-carousel__indicators {
left: unset;
  transform: unset;
  right: 10%;
  bottom:2.4%
}
 /*指示器按钮*/ 

 .lb .el-carousel__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  > i {
    display: block;
    width: 100%;
    height: 100%;
    &::before {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      display: block;
    }
  }
    
    border: none;
    outline: 0;       
    padding: 0;
    margin: 0;        
    height: 3.875vw;  
    width: 3.875vw;   
    cursor: pointer;
    -webkit-transition: all 0.3s ease;  
    transition: all 0.3s ease;
    border-radius: 50%;
    background-color: rgba(31, 45, 61, 0.11); 
    color: #fff;     
    position: absolute;
    top: 50%;
    z-index: 10;
    -webkit-transform: translateY(-50%); 
    transform: translateY(-50%);         
    text-align: center;
    font-size: 3.625vw;

    // 移动端适配
    @media (max-width: 768px) {
        height: 8vw;
        width: 8vw;
        font-size: 4vw;
    }
}
 
 .lb .el-carousel__button {
   width: 5.5rem;
  height: 0.2rem;
  border: none;
  // border-radius: 50%;
  background-color: #fff;
}
/*指示器激活按钮*/
.lb .is-active .el-carousel__button {
  background: #015293;
}

.img_item1{
 width: auto !important;
 height: 100% !important;
 object-fit: cover;
}

::v-deep .el-carousel__button{
  height:0.5rem !important;
  width: 1.5rem !important;
}

::v-deep{
  .el-carousel__arrow{
    width: 3rem !important;
    height: 3rem !important;
    background: #666666;
    opacity: 0.4;
  }
}

.carousel_wrap {
  // margin-top: -10vh;
  @media screen and (max-width: 768px) {
    margin-top: 0vh;
  }
  position: relative;
  .el-carousel__item {
    img {
      width: 100% !important;
      height: 100% !important;
      transition: transform 2.5s ease;
      transform: scale(1.5); /* 放大1.1倍 */
      // object-fit: cover;
    }
  }
  
  .is-active{
    img { 
       height: 100% !important;
      transform: scale(1.0); /* 放大1.1倍 */
      
    }
  }
  .tips_font {
    position: absolute;
    top: 360px;
    left: 0;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    width:100vw;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
    h1.index3{
      font-size:1rem;letter-spacing: 0.5rem;width: 100%;text-align: left; 
      color: #333333;
    }
  }
}
.lbItem{
text-align: center;}
.img_item{
  // height: auto !important;
//  padding-top: 3rem;
 width: 100% !important;
 height: auto !important;
}
 
// * 基础样式 */
.carousel-item {
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}

.slide-content {
  text-align: center;
  color: white;
  padding: 20px;
  max-width: 80%;
}
.slide-content h1{
  color: #fff;
  // text-shadow: 
  //   1px 1px 0 #ccc,
  //   2px 2px 0 #bbb  
  // transform: rotateX(15deg);
  
}

/* 动画定义 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideDown {
  from { 
    opacity: 0;
    transform: translateY(-50px); 
  }
  to { 
    opacity: 1;
    transform: translateY(0); 
  }
}

 
.animated-title, .animated-text {
  opacity: 0;
  transform: translateY(-150px);
}

.animated-title.animate {
  animation: fadeInDown 0.8s ease forwards;
}

.animated-text.animate {
  animation: fadeInDown 1s ease 0.3s forwards;
}

@keyframes fadeInDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>